//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: 'AppScore',
  props: ['score'],
  computed: {
    scoreImage: function scoreImage() {
      var score = Math.round(this.score * 10);
      var imageName = 'rating/s' + score + '.svg';
      return OC.imagePath('core', imageName);
    }
  }
};